<template>
  <b-card-actions noActions>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h4 class="mb-0">Owner</h4>

      <b-button
        v-if="input.owner_id"
        variant="outline-primary"
        size="sm"
        @click="isOwnerDetailModalOpen = true"
      >
        <feather-icon icon="EyeIcon" class="mr-50" />View Detail
      </b-button>
    </div>

    <validation-observer v-if="!id" ref="observer" v-slot="{ validate }">
    <b-row>
      <b-col md="12">
        <b-form-group>
          <div class="d-flex justify-content-between align-items-center">
            <label class="mb-0">Owner of property <span class="text-danger">*</span></label>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              @click="formowner_show"
              variant="flat-primary"
              size="sm"
              class="p-0"
            >
              <feather-icon icon="PlusCircleIcon" class="mr-25" />New Owner
            </b-button>
          </div>
          <small class="text-muted d-block mb-50">Search by name, phone, or email</small>

          <validation-provider
            v-slot="{ errors, valid, validated }"
            rules="required"
            name="owner"
          >
            <b-form-group class="mb-0" :class="{
                  'is-invalid': errors.length,
                  'is-valid': validated && valid
                }">
              <vue-autosuggest
                ref="autocomplete"
                v-model="ownerQuery"
                :suggestions="suggestions"
                :input-props="{
                  ...inputProps,
                  class: [
                    inputProps.class,
                    errors.length ? 'is-invalid' : '',
                    validated && valid ? 'is-valid' : ''
                  ]
                }"
                :section-configs="sectionConfigs"
                :render-suggestion="renderSuggestion"
                :get-suggestion-value="getSuggestionValue"
                @input="fetchResults"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    </validation-observer>

    <div v-if="input.owner_id" class="owner-summary p-1 mb-1">
      <b-row>
        <b-col md="6">
          <b-form-group label="First name" class="mb-1 mb-md-0">
            <b>{{ owner.owner_firstname || '' }}</b>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Last name" class="mb-1 mb-md-0">
            <b>{{ owner.owner_lastname || '' }}</b>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Email" class="mb-0">
            <b>{{ owner.owner_emails.join(', ') }}</b>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Phone No." class="mb-0">
            <b>{{ owner.owner_phones? owner.owner_phones.join(', '): '' }}</b>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-modal
      v-model="isOwnerDetailModalOpen"
      title="Owner Detail"
      size="xl"
      hide-footer
      scrollable
    >
      <clients-form v-if="isOwnerDetailModalOpen" :preset-id="input.owner_id" />
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      v-model="isSidebarownerOpen"
      bg-variant="white"
      right
      backdrop
      shadow
      no-header
      class="side-bar-responsive"
    >
      <div class="d-flex justify-content-between align-items-center px-2 py-1 border-bottom">
        <h5 class="mb-0">Add Owner</h5>

        <feather-icon
          icon="XIcon"
          size="16"
          class="cursor-pointer"
          @click="formowner_hide"
        />
      </div>

      <owners-formpopup
        v-if="isSidebarownerOpen"
        @childToOwner="formowner_hide"
      />
    </b-sidebar>

  </b-card-actions>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup, BRow, BCol, BSidebar, VBToggle, BButton, BModal, VBTooltip,
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
import { MIN_USER_KEYWORD, searchUsers } from '@core/utils/user-autocomplete'
import Ripple from 'vue-ripple-directive'
import OwnersFormpopup from '../../users/owner/owner-form/OwnersFormPopup.vue'
import ClientsForm from '../../users/client/client-form/ClientsForm.vue'
import router from '@/router'

export default {
  components: {
    BCardActions,
    VueAutosuggest,
    BFormGroup,
    BRow,
    BCol,
    BSidebar,
    BButton,
    BModal,
    OwnersFormpopup,
    ClientsForm,
    ValidationProvider,
    ValidationObserver
  },

  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {
    parentData: Object,
    id: [String, Number],
  },

  data() {
    return {
      input: {
        owner_id: null,
      },
      ownerQuery: '',
      owner: {
        owner_firstname: '',
        owner_lastname: '',
        owner_emails: [],
        owner_phones: [],
      },
      owId: router.currentRoute.params.ownerId,
      suggestions: [],
      isSidebarownerOpen: false,
      isOwnerDetailModalOpen: false,
      debounceMilliseconds: 400,
      timeout: null,

      inputProps: {
        placeholder: 'Owner of property',
        class: 'form-control',
      },

      sectionConfigs: {
        owner: {
          limit: 20,
          label: 'Owners',
          onSelected: ({ item }) => {
            this.setOwner(item)
          },
        },
      },
    }
  },
  created() {
    if (this.id) this.getProperty()
    if (this.owId) this.getOwnerById()
  },
  methods: {
    async setOwner(item, fetchDetail = true) {
      const ownerId = item.owner_id || item.id
      if (!ownerId) return

      this.input.owner_id = ownerId
      this.ownerQuery = `${item.owner_firstname} ${item.owner_lastname || ''}`

      if (fetchDetail) {
        await this.fetchOwnerDetail(ownerId)
      }

      this.$emit('childToParent', this.input)
    },
    async fetchOwnerDetail(ownerId) {
      try {
        const res = await axios.post('users/v1/lists', { id: ownerId })
        const owner = res?.data?.data?.[0]
        if (!owner) return

        this.owner = {
          owner_firstname: owner.firstname || '',
          owner_lastname: owner.lastname || '',
          owner_emails: owner.emails?.map(e => e.email) || [],
          owner_phones: owner.phones?.map(p => p.phone_no) || [],
        }
      } catch (err) {
        console.error('Failed to fetch owner detail', err)
      }
    },
    async getOwnerById() {
      try {
        const res = await axios.get(`users/v1/detail/${this.owId}`)
        const usr = res?.data?.data
        if (!usr?.id) return

        this.owner = {
          owner_firstname: usr.firstname || '',
          owner_lastname: usr.lastname || '',
          owner_emails: usr.owner_emails || [],
          owner_phones: usr.owner_phones || [],
        }

        this.setOwner(
          {
            owner_id: usr.id,
            owner_firstname: usr.firstname,
            owner_lastname: usr.lastname,
          },
          false
        )
      } catch (err) {
        console.error(err)
      }
    },
    async getProperty() {
      try {
        const res = await axios.get(`property/v1/getdetail/${this.id}`)
        const property = res?.data?.data?.[0]
        if (!property?.owner_id) return

        this.setOwner(property)
      } catch (err) {
        console.error(err)
      }
    },
    fetchResults() {
      // One character matches ~6,000 owners and the endpoint returns all of them; see user-autocomplete.js
      if (!this.ownerQuery || this.ownerQuery.trim().length < MIN_USER_KEYWORD) {
        this.suggestions = []
        return
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.fetchOwnerAutocomplete, this.debounceMilliseconds)
    },
    async fetchOwnerAutocomplete() {
      try {
        this.suggestions = [
          {
            name: 'owner',
            data: await searchUsers(this.ownerQuery),
          },
        ]
      } catch (err) {
        console.error(err)
      }
    },
    renderSuggestion({ item }) {
      return `${item.owner_firstname} ${item.owner_lastname || ''}`
    },
    getSuggestionValue({ item }) {
      return `${item.owner_firstname} ${item.owner_lastname || ''}`
    },
    formowner_show() {
      this.isSidebarownerOpen = true
    },
    formowner_hide() {
      this.isSidebarownerOpen = false
    },
    async validateForm() {
      if (!this.$refs.observer) return true
      const valid = await this.$refs.observer.validate()
      return valid
    },
  },
}
</script>

<style scoped>
.form-group.is-invalid {
  border-left: 3px solid #ea5455;
  background-color: rgba(234, 84, 85, 0.06);
  border-radius: 0.357rem;
  padding: 0.75rem 0.75rem 0.5rem;
}
</style>